import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { decryptStorage } from 'utils/utils';
import { API_BEMYSELF } from "../../config/config.json";

const prepareHeaders = (includeAuthorization = true) => (headers) => {
    headers.set('content-type', 'application/json');
    headers.set('accept', '*/*');
    headers.set('Accept-Encoding', 'gzip, deflate, br');
    headers.set('Connection', 'keep-alive');

    if (includeAuthorization) {
        const token = decryptStorage(localStorage.getItem("tokenBeMyself"));
        if (token) headers.set('Authorization', `Bearer ${token}`);
    }

    return headers;
};

const baseQuery = fetchBaseQuery({
    baseUrl: API_BEMYSELF,
    extraOptions: { timeout: 30000 },
    prepareHeaders: prepareHeaders(true), // Por defecto, se incluye la autorización
    fetchFn: async (url, options, ...args) => {
        if (url.url.startsWith('http')) {
            return fetch(url, options, ...args);
        }
        return fetchBaseQuery({
            baseUrl: API_BEMYSELF,
            extraOptions: { timeout: 30000 },
            prepareHeaders: prepareHeaders(true),
        })(url, options, ...args);
    }
});

export const microServiceBeMyselfAPI = createApi({
    reducerPath: 'microServiceBeMyselfAPI',
    baseQuery,
    endpoints: () => ({})
});

